/**
 * algorithm-users-broadcast.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { Collaborator } from "../../../auth/identity/collaborator";
import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * When the client requests access to a shared resource, the server sends an
 * unsolicited {@link AlgorithmUsersBroadcast} that enumerates all users
 * currently accessing the resource. Users are reported opaquely — public and
 * internal identifiers are not exposed, just the user's full name and group.
 */
@validateFor(MessageTag.BCST_ALGORITHM_USERS)
export class AlgorithmUsersBroadcast extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.BCST_ALGORITHM_USERS;

  /**
   * A list of users currently present in the algorithm.
   */
  @validateAs({array: "object"}) // TODO: better validation
  public users : Collaborator[];

  /**
   * The ID corresponding to a user that just left the algorithm.
   */
  @validateOpaqueID(false, null, true)
  public removedId : number | null;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/algorithms/algorithm-users-broadcast.ts